<div class="row c-row">
  <div class="col-sm-4 my-5" *ngIf="!isOrganizationUser && !currentUserData.delegateAccess">
    <img mat-card-lg-image *ngFor="let preview of previews" [src]="preview" class="preview">

    <div class="mt-3">
      <div class="mb-2" (click)="uploadFile.click()">
        <button mat-raised-button>
          <mat-icon>edit</mat-icon> Browse Photo
        </button>
        <input #uploadFile (change)="selectFiles($event)" type="file" style="display:none"
          accept="image/png, image/jpeg" />
      </div>
      <button mat-raised-button color="primary" (click)="onClickUploadProfile()">
        <mat-icon>upload</mat-icon> Upload Photo
      </button>
    </div>
  </div>

  <div class="col-sm-4 my-5" [ngClass]="{'col-sm-4 my-5' : isOrganizationUser} "
    *ngIf="!currentUserData.delegateAccess">
    <img *ngIf="logoPreviewUrl; else serverLogo" [src]="logoPreviewUrl" class="logo-preview" alt="Logo preview" />

    <ng-template #serverLogo>
      <img *ngIf="previewsLogo?.length" [src]="previewsLogo[0]" class="logo-preview" alt="Current logo" />
    </ng-template>

    <div class="mt-3">
      <div class="mb-2" (click)="uploadLogoFile.click()">
        <button mat-raised-button class="btn-browse">
          <mat-icon>edit</mat-icon> Browse Image
        </button>
        <input #uploadLogoFile type="file" accept="image/png,image/jpeg" (change)="onLogoFileSelected($event)" hidden />
      </div>

      <!-- <div class="meta" *ngIf="logoOriginalSize || logoCompressedSize">
        <small *ngIf="logoOriginalSize">Original: {{ logoOriginalSize }}</small>
        <small *ngIf="logoCompressedSize" class="ms-2">Compressed: {{ logoCompressedSize }}</small>
      </div> -->

      <div class="upload-inline">
        <button mat-raised-button color="primary" (click)="uploadLogo()">
          <mat-icon>upload</mat-icon>
          {{ uploading ? 'Upload Logo' : 'Upload Logo' }}
        </button>
        <mat-icon [matTooltip]="logoTip" [matTooltipClass]="'pre-wrap-tooltip'" matTooltipPosition="below">info</mat-icon>
      </div>
    </div>
  </div>

  <div class="col-sm-4 my-5 mt-5" [ngClass]="{'col-sm-4 my-5' : isOrganizationUser} "
    *ngIf="!currentUserData.delegateAccess">
    <img *ngIf="previewUrl; else serverCover" [src]="previewUrl" class="cover-preview" alt="Preview" />

    <ng-template #serverCover>
      <img *ngIf="previewsCover?.length" [src]="previewsCover[0]" class="cover-preview" alt="Current cover" />
    </ng-template>

    <div class="mt-5">
       <!-- <div class="mb-2" (click)="coverFile.click()">
        <button mat-raised-button>
          <mat-icon>edit</mat-icon> Browse Image
        </button>
        <input #coverFile (change)="onCoverFilesSelected($event)" type='file' accept="image/png,image/jpeg" style="display:none" />
      </div>
      <button mat-raised-button color="primary" (click)="onClickUploadCover()">
        <mat-icon>upload</mat-icon> Upload Cover
      </button> -->  
      <div class="mt-3">
        <div class="mb-2 uploader">
          <button type="button" class="btn-browse" mat-raised-button
            (click)="fileInput.click()"><mat-icon>edit</mat-icon> Browse image</button>
          <input #fileInput type="file" accept="image/png,image/jpeg" (change)="onFileSelected($event)" hidden>

          <!-- <div class="meta" *ngIf="originalSize || compressedSize">
            <small *ngIf="originalSize">Original: {{ originalSize }}</small>
            <small *ngIf="compressedSize" class="ms-2">Compressed: {{ compressedSize }}</small>
          </div> -->
        </div>

        <div class="upload-inline">
          <button mat-raised-button color="primary" (click)="upload()"> <mat-icon>upload</mat-icon>
            {{ uploading ? 'Upload Cover' : 'Upload Cover' }}
          </button>
          <mat-icon class="info-icon" [matTooltip]="allSpecsTip" [matTooltipClass]="'pre-wrap-tooltip'"
            matTooltipPosition="below" aria-label="Image upload requirements">
            info
          </mat-icon>
        </div>
      </div>

      <div class="text-muted small mt-1" *ngIf="selectedCoverMeta.bytes && !coverError">
        Selected: {{ prettyBytes(selectedCoverMeta.bytes!) }}
        <span *ngIf="selectedCoverMeta.w && selectedCoverMeta.h">
          · {{ selectedCoverMeta.w }}×{{ selectedCoverMeta.h }} (≈{{ selectedCoverMeta.ratio }}:1)
        </span>
      </div>

      <div class="text-danger small mt-1" *ngIf="coverError">
        {{ coverError }}<br>
        <span class="text-muted">
          Recommended 3200×400 (8:1) · JPG/PNG · ≥ {{ minCoverKB }} KB and ≤ {{ maxCoverMB }} MB · Min 1299×160
        </span>
      </div>
    </div>
  </div>

  <div class="col-sm-4 mt-3 row">
    <div class="col-sm-10">
      <img *ngIf="businessQRCode" mat-card-image height="200" width="180" [src]="businessQRCode">
    </div>
    <div class="col-sm-2">
      <div class="col-sm-12">
        <a *ngIf="businessQRCode" href="#!" mat-icon-button matTooltip="Copy URL" color="primary"
          (click)="onClickCopyURL()">
          <i class="fa fa-copy" style="font-size: 30px;"></i>
        </a>

        <a *ngIf="businessQRCode" href="#!" mat-icon-button matTooltip="Download QR" color="primary"
          (click)="onClickDownloadQrCode($event)">
          <i class="fa fa-download" style="font-size: 30px;"></i>
        </a>
      </div>
    </div>
  </div>
</div>

<div *ngIf="!currentUserData.delegateAccess">
  <form [formGroup]="userProfileForm1" (ngSubmit)="onClickUserProfileForm1()" autocomplete="off">
    <div class="row c-row">
      <div class="col-sm-8">
        <mat-form-field>
          <mat-label>Website URL (Optional)</mat-label>
          <input matInput formControlName="web_url" placeholder="Enter optional info" maxlength="50" type="text">
        </mat-form-field>
      </div>
      <div class="col-sm-4">
        <mat-form-field>
          <mat-label>Slug</mat-label>
          <input matInput formControlName="slug" placeholder="Slug" type="text" maxlength="16">
          <mat-error *ngIf="(submittedUserProfileForm1 || f1.slug.touched) && f1.slug.errors?.required" class="invalid-feedback">
            Slug is required
          </mat-error>
          <mat-error *ngIf="(submittedUserProfileForm1 || f1.slug.touched) && f1.slug.errors?.pattern" class="invalid-feedback">
            Only lower case and numbers allowed
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="row c-row">
      <div class="col-sm-4">
        <mat-form-field>
          <mat-label>First Name</mat-label>
          <input matInput formControlName="firstName" placeholder="First Name" type="text" maxlength="25">
          <mat-error *ngIf="(submittedUserProfileForm1 || f1.firstName.touched) && f1.firstName.errors?.required" class="invalid-feedback">
            First name is required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-4">
        <mat-form-field>
          <mat-label>Last Name</mat-label>
          <input matInput formControlName="lastName" placeholder="Last Name" type="text" maxlength="25">
          <mat-error *ngIf="(submittedUserProfileForm1 || f1.lastName.touched) && f1.lastName.errors?.required" class="invalid-feedback">
            Last name is required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-4">
        <mat-form-field>
          <mat-label>Company</mat-label>
          <input matInput formControlName="company" placeholder="Company" type="text" maxlength="40">
          <mat-icon matSuffix matTooltip="Enter Organization/Company Name to displayed on Customer app">info</mat-icon>
          <mat-error *ngIf="(submittedUserProfileForm1 || f1.company.touched) && f1.company.errors?.required" class="invalid-feedback">
            Company name is required
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="row c-row">
      <div class="col-sm-12">
        <mat-form-field fxFlex="100" fxFlex.lt-md="100" fxFlex.lt-sm="100">
          <mat-label>Address</mat-label>
          <input matInput formControlName="address" placeholder="Address" type="text" maxlength="100">
          <mat-error *ngIf="(submittedUserProfileForm1 || f1.address.touched) && f1.address.errors?.required" class="invalid-feedback">
            Address is required
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="row c-row">
      <div class="col-sm-4">
        <mat-form-field>
          <mat-label>Country</mat-label>
           <!-- <mat-select formControlName="countryId" (selectionChange)="onChangeCountry($event)">
            <mat-option>--None--</mat-option>
            <mat-option *ngFor="let country of countryList" [value]="country.id">
              {{country.name}}
            </mat-option>
          </mat-select> -->
          <input type="text" matInput AlphabeticOnly formControlName="countryId"
            (ngModelChange)="onChangeCountry($event)" [matAutocomplete]="autoCountryId" autocomplete="disabled">
          <mat-autocomplete #autoCountryId="matAutocomplete" [displayWith]="displayFnCountry">
            <mat-option *ngFor="let country of countryFilterList" [value]="country.id">
              {{ country.name }}
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="submittedUserProfileForm1 && f1.countryId.errors?.required" class="invalid-feedback">
            Country is required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-4">
        <mat-form-field>
          <mat-label>State/Province</mat-label>
             <!-- <mat-select formControlName="stateId" (selectionChange)="onChangeState($event)">
            <mat-option>--None--</mat-option>
            <mat-option *ngFor="let state of stateList" [value]="state.id">
              {{state.name}}
            </mat-option>
          </mat-select> -->
          <input type="text" matInput AlphabeticOnly formControlName="stateId" (ngModelChange)="onChangeState($event)"
            [matAutocomplete]="autoStateId" autocomplete="disabled">
          <mat-autocomplete #autoStateId="matAutocomplete" [displayWith]="displayFnState">
            <mat-option *ngFor="let state of stateFilterList" [value]="state.id">
              {{ state.name }}
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="(submittedUserProfileForm1 || f1.stateId.touched) && f1.stateId.errors?.required" class="invalid-feedback">
            State/Province is required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-4">
        <mat-form-field>
          <mat-label>City</mat-label>
            <!-- <mat-select formControlName="cityId">
            <mat-option>--None--</mat-option>
            <mat-option *ngFor="let city of cityList" [value]="city.id">
              {{city.name}}
            </mat-option>
          </mat-select> -->
          <input type="text" matInput AlphabeticOnly formControlName="cityId" (ngModelChange)="onChangeCity($event)"
            [matAutocomplete]="autoCityId" autocomplete="disabled">
          <mat-autocomplete #autoCityId="matAutocomplete" [displayWith]="displayFnCity">
            <mat-option *ngFor="let city of cityFilterList" [value]="city.id">
              {{ city.name }}
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="(submittedUserProfileForm1 || f1.cityId.touched) && f1.cityId.errors?.required" class="invalid-feedback">
            City is required
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="row c-row">
      <div class="col-sm-8">
        <mat-form-field fxFlex="33" fxFlex.lt-md="50" fxFlex.lt-sm="100">
          <mat-label>Email</mat-label>
          <input matInput formControlName="email" oninput="this.value = this.value.toLowerCase()" placeholder="Email ID"
            type="email" maxlength="50" readonly>
          <mat-error *ngIf="(submittedUserProfileForm1 || f1.email.touched) && f1.email.errors?.required" class="invalid-feedback">
            Email ID is required
          </mat-error>
          <mat-error *ngIf="(submittedUserProfileForm1 || f1.email.touched) && f1.email.errors?.pattern" class="invalid-feedback">
            Please enter valid Email ID
          </mat-error>
        </mat-form-field>
      </div>
           <!-- <div class="col-sm-2">
        <mat-form-field fxFlex="33" fxFlex.lt-md="50" fxFlex.lt-sm="100">
          <mat-label>Country Code</mat-label>
          <input matInput formControlName="countryCode" placeholder="Country Code" type="text">
          <mat-error *ngIf="submittedUserProfileForm1 && f1.countryCode.errors?.required" class="invalid-feedback">
            Country Code is required
          </mat-error>
        </mat-form-field>
      </div> -->
      <div class="col-sm-4">
        <mat-form-field fxFlex="33" fxFlex.lt-md="50" fxFlex.lt-sm="100">
          <mat-label>Telephone</mat-label>
          <span matPrefix>+{{ countryCode }} &nbsp;</span>
          <input matInput formControlName="telephone" placeholder="Telephone" type="tel" maxlength="15"
            (keypress)="onlyNumbers($event)">
          <mat-error *ngIf="(submittedUserProfileForm1 || f1.telephone.touched) && f1.telephone.errors?.required" class="invalid-feedback">
            Telephone is required
          </mat-error>
          <mat-error class="invalid-feedback"
            *ngIf="(submittedUserProfileForm1 || f1.telephone.touched) && (f1.telephone.errors?.minlength || f1.telephone.errors?.maxlength)">
            Mobile number should be of 8-15 digits
          </mat-error>
          <mat-error class="invalid-feedback" *ngIf="(submittedUserProfileForm1 || f1.telephone.touched) && f1.telephone.errors?.pattern">
            Only numeric digits are allowed
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="row c-row">
      <div class="col-sm-3">
        <button mat-raised-button type="submit" color="primary"
          [disabled]="!isFormChanged || userProfileForm1.invalid || isSubmitting">
          Save
        </button>
      </div>
    </div>
  </form>
</div>
<!-- <hr>
<div class="row c-row" *ngIf="businessQRCode">
  <div class="col-sm-9">
    <div class="row c-row">
      <div class="col-sm-5 my-5">
        <img class="mat-card-lg-logo-image" *ngIf="selectedLogoFileNames.length == 0"
          src="../../../../assets/images/sf_logo.png">
        <img class="mat-card-lg-logo-image preview" *ngFor='let preview of previewsLogo' [src]="preview">
      </div>
      <div class="col-sm-7">
        <div class="mt-3">
          <div class="mb-2" (click)="uploadLogoFile.click()">
            <button mat-raised-button>
              <mat-icon>edit</mat-icon> Edit Logo
            </button>
            <input #uploadLogoFile (change)="selectLogoFiles($event)" type='file' style="display:none" />
          </div>
          <button mat-raised-button color="primary" (click)="onClickUploadLogo()">
            <mat-icon>upload</mat-icon> Upload Logo
          </button>
        </div>
      </div>
    </div>
  </div>
</div> -->